<template>
  <div class="app">
    <app-header/>
    <main class="app__main">
      <router-view/>
    </main>
    <app-footer/>
  </div>
</template>

<script>
import AppHeader from './components/Header/AppHeader';
import AppFooter from './components/Footer/AppFooter';

export default {
  components: {
    AppHeader,
    AppFooter,
  },
};
</script>

<style lang="scss" scoped>
  .app {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
    &__main {
      flex-grow: 1;
    }
  }
</style>
